export const ROUTE_SCHEDULES = 'ROUTE_SCHEDULES'
